{
  "Clear search": "Aramayı temizle"
}
